import React from "react";
import { ToolCallDetails as SharedToolCallDetails } from "@photon/chat-react/activity-timeline";

const ToolCallDetails = ({
  code,
  args,
  hint,
  size_hint,
  result_preview,
  stdout,
  stderr,
  isRunning = false,
  cancellationLimitation,
}) => (
  <SharedToolCallDetails
    code={code}
    args={args}
    hint={hint}
    sizeHint={size_hint}
    resultPreview={result_preview}
    stdout={stdout}
    stderr={stderr}
    isRunning={isRunning}
    cancellationLimitation={cancellationLimitation}
  />
);

export default ToolCallDetails;